import { useEffect } from "react";

import ROUTES from "@app/common/routes";
import { withQueryParamsUrl } from "@app/common/utils";
import Config from "@app/config";
import logger from "@app/utils/logger";
import { loadScript } from "@app/utils/scripts";
import { getAppUrl } from "@app/utils/utils";

const SCRIPT_ID = "readMeetShareAddon";
const SCRIPT_SRC =
  "https://www.gstatic.com/meetjs/addons/0.7.0/meet.addons.screenshare.js";

const useExposeToMeet = ({ sessionId }: { sessionId: string }) => {
  useEffect(() => {
    loadScript({ src: SCRIPT_SRC, id: SCRIPT_ID })
      .then(() => {
        const payload = {
          cloudProjectNumber: Config.apps.meet.CLOUD_PROJECT_NUMBER,
          startActivityOnOpen: true,
          sidePanelUrl: getAppUrl(
            withQueryParamsUrl(ROUTES.NOTETAKER, {
              client: "meet",
              screenshare: "true",
              sessionId,
            })
          ),
          additionalData: JSON.stringify({ sessionId }),
        };
        logger.log("screenshare payload", JSON.stringify(payload));

        try {
          window.meet.addon.screensharing.exposeToMeetWhenScreensharing(
            payload
          );
        } catch (e) {
          logger.error("Error exposing to Meet:", e);
        }
      })
      .catch(() => {
        logger.log("failed to load meet addon screenshare script");
      });
  }, [sessionId]);
};

export default useExposeToMeet;
